export const ON_CPT_QUERY_INPUT_CHANGE = 'CPT/ON_CPT_QUERY_INPUT_CHANGE';

export const START_LOAD_CPT_INFO = 'CPT/START_LOAD_CPT_INFO';
export const LOAD_CPT_INFO_SUCCESS = 'CPT/LOAD_CPT_INFO_SUCCESS';
export const LOAD_CPT_INFO_FAILURE = 'CPT/LOAD_CPT_INFO_FAILURE';
export const INIT_LOAD_CPT_INFO_ACTION_STATUS = 'CPT/INIT_LOAD_CPT_INFO_ACTION_STATUS';

export const SELECT_CPT_INFO = 'CPT/SELECT_CPT_INFO';

export const OPEN_ADD_OR_EDIT_CPT_MODAL = 'CPT/OPEN_ADD_OR_EDIT_CPT_MODAL';
export const ADD_OR_EDIT_CPT_CHANGE_INPUT = 'CPT/ADD_OR_EDIT_CPT_CHANGE_INPUT';
export const START_ADD_OR_EDIT_CPT = 'CPT/START_ADD_OR_EDIT_CPT';
export const ADD_OR_EDIT_CPT_SUCCESS = 'CPT/ADD_OR_EDIT_CPT_SUCCESS';
export const ADD_OR_EDIT_CPT_FAILURE = 'CPT/ADD_OR_EDIT_CPT_FAILURE';
export const INIT_ADD_OR_EDIT_CPT_ACTION_STATUS = 'CPT/INIT_ADD_OR_EDIT_CPT_ACTION_STATUS';
export const RESET_ADD_OR_EDIT_CPT_MODAL = 'CPT/RESET_ADD_OR_EDIT_CPT_MODAL';

export const OPEN_DEL_CPT_MODAL = 'CPT/OPEN_DEL_CPT_MODAL';
export const START_DEL_CPT = 'CPT/START_DEL_CPT';
export const DEL_CPT_SUCCESS = 'CPT/DEL_CPT_SUCCESS';
export const DEL_CPT_FAILURE = 'CPT/DEL_CPT_FAILURE';
export const INIT_DEL_CPT_ACTION_STATUS = 'CPT/INIT_DEL_CPT_ACTION_STATUS';
export const RESET_DEL_CPT_MODAL = 'CPT/RESET_DEL_CPT_MODAL';

export const START_SUBMIT_CPT = 'CPT/START_SUBMIT_CPT';
export const SUBMIT_CPT_SUCCESS = 'CPT/SUBMIT_CPT_SUCCESS';
export const SUBMIT_CPT_FAILURE = 'CPT/SUBMIT_CPT_FAILURE';
export const INIT_SUBMIT_CPT_ACTION_STATUS = 'CPT/INIT_SUBMIT_CPT_ACTION_STATUS';
